/**
 * Any of these `pages.slug` values are served at the site root `/` (see `(frontend)/page.tsx` + `[slug]/page.tsx`).
 * The `[slug]` route defaults missing `slug` to `home`, then we look up a published page with any of these slugs.
 */
export const ROOT_PAGE_SLUGS = ['home', 'homepage', '/', '', 'crafted-projects', 'contact-us', 'about-us', 'our-process'] as const

export function isRootPageSlug(slug: string | null | undefined): boolean {
  if (slug == null) return false
  return (ROOT_PAGE_SLUGS as readonly string[]).includes(slug)
}

/** Path used for ISR revalidation and redirect `from` matching. */
const HOME_SLUGS = ['home', 'homepage', '/', ''] as const

export function pagePathForSlug(slug: string): string {
  return (HOME_SLUGS as readonly string[]).includes(slug) ? '/' : `/${slug}`
}
